export default __webpack_public_path__ + "static/media/nic.07de554d.jpg";